// Constantes pour le formulaire d'identification d'institutions financières

export const ORGANIZATION_TYPES = [
  { value: 'enterprise', label: 'Entreprise (PME/Startup)' },
  { value: 'financial_institution', label: 'Institution Financière' },
] as const;

export const FINANCIAL_INSTITUTION_TYPES = [
  { value: 'BANQUE', label: 'Banque commerciale' },
  { value: 'MICROFINANCE', label: 'Institution de microfinance (IMF)' },
  { value: 'COOPEC', label: 'Coopérative d\'épargne et de crédit (COOPEC)' },
  { value: 'FOND_GARANTIE', label: 'Fonds de garantie' },
  { value: 'ENTREPRISE_FINANCIERE', label: 'Entreprise financière' },
  { value: 'FOND_CAPITAL_INVESTISSEMENT', label: 'Fonds de capital investissement' },
  { value: 'FOND_IMPACT', label: 'Fonds d\'impact' },
  { value: 'AUTRE', label: 'Autre institution spécialisée' },
] as const;

export const FINANCIAL_INSTITUTION_SUBTYPES = {
  BANQUE: [
    { value: 'deposit_credit_bank', label: 'Banque de dépôt et de crédit' },
    { value: 'business_bank', label: 'Banque d\'affaires' },
    { value: 'investment_bank', label: 'Banque d\'investissement' },
  ],
  MICROFINANCE: [
    { value: 'microfinance_company', label: 'Société de microfinance' },
    { value: 'microfinance_program', label: 'Programme de microfinance' },
    { value: 'credit_union', label: 'Union de crédit' },
  ],
  COOPEC: [
    { value: 'savings_credit_coop', label: 'Coopérative d\'épargne et de crédit' },
    { value: 'rural_coop', label: 'Coopérative rurale' },
    { value: 'urban_coop', label: 'Coopérative urbaine' },
  ],
  FOND_GARANTIE: [
    { value: 'sme_guarantee', label: 'Fonds de garantie PME' },
    { value: 'agriculture_guarantee', label: 'Fonds de garantie agricole' },
    { value: 'export_guarantee', label: 'Fonds de garantie export' },
  ],
  ENTREPRISE_FINANCIERE: [
    { value: 'leasing', label: 'Société de crédit-bail (leasing)' },
    { value: 'factoring', label: 'Société d\'affacturage' },
    { value: 'consumer_credit', label: 'Crédit à la consommation' },
  ],
  FOND_CAPITAL_INVESTISSEMENT: [
    { value: 'venture_capital', label: 'Capital-risque' },
    { value: 'growth_capital', label: 'Capital-développement' },
    { value: 'private_equity', label: 'Capital-investissement' },
  ],
  FOND_IMPACT: [
    { value: 'social_impact', label: 'Fonds d\'impact social' },
    { value: 'environmental_impact', label: 'Fonds d\'impact environnemental' },
    { value: 'blended_finance', label: 'Finance mixte' },
  ],
  AUTRE: [
    { value: 'asset_management', label: 'Société de gestion d\'actifs' },
    { value: 'stock_exchange', label: 'Bourses et marchés financiers' },
    { value: 'exchange_bureau', label: 'Bureau de change' },
    { value: 'fintech', label: 'Fintech/Néobanque' },
  ],
} as const;

export const SUPERVISORY_AUTHORITIES = [
  { value: 'bcc', label: 'Banque Centrale du Congo (BCC)' },
  { value: 'arca', label: 'Autorité de Régulation et de Contrôle des Assurances (ARCA)' },
  { value: 'asmf', label: 'Autorité des Services et Marchés Financiers (ASMF)' },
  { value: 'other', label: 'Autre autorité' },
] as const;

export const BANKING_SERVICES = [
  { value: 'deposit_collection', label: 'Collecte de dépôts' },
  { value: 'credit_granting', label: 'Octroi de crédits' },
  { value: 'payment_services', label: 'Services de paiement' },
  { value: 'foreign_exchange', label: 'Change et commerce international' },
  { value: 'investment_services', label: 'Services d\'investissement' },
  { value: 'other_banking', label: 'Autres services bancaires' },
] as const;

export const MICROFINANCE_SERVICES = [
  { value: 'savings', label: 'Épargne' },
  { value: 'microcredit', label: 'Microcrédit' },
  { value: 'money_transfers', label: 'Transferts d\'argent' },
  { value: 'microinsurance', label: 'Assurance microfinance' },
  { value: 'financial_education', label: 'Formation financière' },
] as const;

export const INSURANCE_SERVICES = [
  { value: 'life_insurance', label: 'Assurance vie' },
  { value: 'non_life_insurance', label: 'Assurance non-vie' },
  { value: 'reinsurance', label: 'Réassurance' },
  { value: 'insurance_brokerage', label: 'Courtage d\'assurance' },
] as const;

export const FINTECH_SERVICES = [
  { value: 'electronic_payments', label: 'Paiements électroniques' },
  { value: 'online_lending', label: 'Prêts en ligne' },
  { value: 'digital_wealth_management', label: 'Gestion de patrimoine numérique' },
  { value: 'blockchain_crypto', label: 'Blockchain/Cryptomonnaies' },
  { value: 'insurtech', label: 'Insurtech' },
  { value: 'regtech', label: 'Regtech' },
] as const;

export const CLIENT_SEGMENTS = [
  { value: 'individuals', label: 'Particuliers' },
  { value: 'sme', label: 'PME' },
  { value: 'large_enterprises', label: 'Grandes entreprises' },
  { value: 'institutions', label: 'Institutions' },
  { value: 'all_segments', label: 'Tous segments' },
] as const;

export const WANZO_SERVICES_CREDIT = [
  { value: 'sme_credit', label: 'Crédit aux PME' },
  { value: 'startup_credit', label: 'Crédit aux startups' },
  { value: 'leasing', label: 'Crédit-bail/leasing' },
  { value: 'factoring', label: 'Affacturage' },
  { value: 'revolving_credit', label: 'Lignes de crédit revolving' },
] as const;

export const WANZO_SERVICES_INVESTMENT = [
  { value: 'venture_capital', label: 'Capital-risque/Venture capital' },
  { value: 'growth_capital', label: 'Capital-développement' },
  { value: 'project_financing', label: 'Financement de projets' },
  { value: 'equity_investment', label: 'Investissement en actions' },
  { value: 'debt_securities', label: 'Obligations/titres de créance' },
] as const;

export const WANZO_SERVICES_GUARANTEE = [
  { value: 'bank_guarantees', label: 'Garanties bancaires' },
  { value: 'market_bonds', label: 'Cautions de marché' },
  { value: 'guarantee_funds', label: 'Fonds de garantie' },
  { value: 'credit_insurance', label: 'Assurance-crédit' },
] as const;

export const WANZO_SERVICES_TRANSACTIONAL = [
  { value: 'bank_accounts', label: 'Comptes bancaires' },
  { value: 'transfers', label: 'Virements et transferts' },
  { value: 'international_trade', label: 'Commerce international' },
  { value: 'foreign_exchange', label: 'Change et devises' },
  { value: 'electronic_payments', label: 'Paiements électroniques' },
] as const;

export const WANZO_SERVICES_ADVISORY = [
  { value: 'financial_management', label: 'Conseil en gestion financière' },
  { value: 'financial_structuring', label: 'Structuration financière' },
  { value: 'due_diligence', label: 'Due diligence' },
  { value: 'company_valuation', label: 'Évaluation d\'entreprises' },
  { value: 'financial_training', label: 'Formation financière' },
] as const;

export const LEGAL_STATUSES = [
  { value: 'sa', label: 'Société Anonyme (SA)' },
  { value: 'sarl', label: 'Société À Responsabilité Limitée (SARL)' },
  { value: 'cooperative', label: 'Coopérative' },
  { value: 'mutual', label: 'Mutuelle' },
  { value: 'foundation', label: 'Fondation' },
  { value: 'branch', label: 'Succursale d\'institution étrangère' },
  { value: 'other', label: 'Autre forme juridique' },
] as const;

export const PARTNERSHIP_MOTIVATIONS = [
  { value: 'new_clients', label: 'Accès à de nouveaux clients' },
  { value: 'portfolio_diversification', label: 'Diversification du portefeuille' },
  { value: 'innovation_exposure', label: 'Exposition aux nouvelles technologies' },
  { value: 'ecosystem_reputation', label: 'Association à un écosystème reconnu' },
  { value: 'market_expansion', label: 'Expansion sur de nouveaux marchés' },
  { value: 'strategic_partnership', label: 'Partenariat stratégique' },
] as const;

export const YES_NO_OPTIONS = [
  { value: 'oui', label: 'Oui' },
  { value: 'non', label: 'Non' },
] as const;

export const CURRENCIES = [
  { value: 'USD', label: 'Dollar US ($)' },
  { value: 'CDF', label: 'Franc congolais (FC)' },
  { value: 'EUR', label: 'Euro (€)' },
] as const;